import { Typography } from "antd"
import { memo, useMemo } from "react"

import Flex from "#blocks/Flex"

const { Text } = Typography

interface SegmentDetailRowProps {
  values: Array<string | undefined>
}

const SegmentDetailRow = memo(({ values }: SegmentDetailRowProps) => {
  const details = useMemo(
    () => values.filter((value) => !!value?.trim()) as string[],
    [values]
  )

  if (!details.length) {
    return (
      <Text type="secondary" style={{ fontSize: 14, fontStyle: "italic" }}>
        Click here to update project details
      </Text>
    )
  }

  return (
    <Flex gap={8} style={{ alignItems: "center", flexWrap: "wrap" }}>
      {details.map((value, index) => (
        <Flex
          key={`${index}-${value}`}
          gap={8}
          style={{ alignItems: "center" }}
        >
          <Text type="secondary" style={{ fontSize: 14 }}>
            {value}
          </Text>
          {index < details.length - 1 && (
            <Text type="secondary" style={{ fontSize: 14 }}>
              |
            </Text>
          )}
        </Flex>
      ))}
    </Flex>
  )
})

SegmentDetailRow.displayName = "SegmentDetailRow"

export default SegmentDetailRow
